import React, { useEffect, useState } from "react";
import { ModalClosed } from "~misc/icons";
import "./index.scss";
import Select from "~components/Form/components/Select";
import Loader from "~components/Form/components/Loader";

const ModalCepOperacional = ({
  isOpen,
  onClose,
  ruas,
  onSelect
}) => {
  const [selectedStreet, setSelectedStreet] = useState("");

  useEffect(() => {
    if (isOpen) setSelectedStreet("");
  }, [isOpen]);

  const modalClasses = isOpen
    ? "fixed inset-0 z-[99999] flex items-center justify-center"
    : "hidden";
  const overlayClasses = isOpen
    ? "fixed inset-0 bg-black opacity-50 z-40"
    : "hidden";

  if (!isOpen) return null;

  return (
    <div className={modalClasses}>
      <div className={overlayClasses} onClick={onClose}></div>
      <div className="bg-white min-w-[680px] max-h-[80vh] flex flex-col px-10 py-10 rounded-[20px] shadow-lg z-50 relative">
        <div className="flex justify-end">
          <button
            type="button"
            onClick={onClose}
            className="text-gray-500 p-4 rounded-tr-[20px] hover:text-gray-700 bg-quinaria absolute top-0 right-0"
          >
            <ModalClosed />
          </button>
        </div>

        <div className="w-full flex justify-center items-center flex-col">
          <h3 className="font-bold text-2xl mb-2 text-center">
            Selecione uma rua
          </h3>
          <p className="text-center text-gray-500 mb-6 w-[80%]">
            O CEP informado é geral para a cidade. Selecione a rua específica para preencher o endereço corretamente.
          </p>
        </div>
        {ruas && ruas.length > 0 ? (
          <>
            <Select 
              options={ruas
                .filter((rua) => rua.logradouro)
                .map((rua) => ({ label: rua.logradouro, value: rua }))
              } 
              onChange={(opt) => {
                const rua = opt.value;
                setSelectedStreet(rua);
              }}
            />

            {selectedStreet && (
              <div className="mt-4 p-4 border border-gray-200 rounded-lg">
                <div className="space-y-1">
                  <div className="flex justify-between">
                    <span>Rua:</span>
                    <span className="font-semibold text-right">{selectedStreet.logradouro}</span>
                  </div>
                  <div className="flex justify-between">
                    <span>Bairro:</span>
                    <span className="font-semibold text-right">{selectedStreet.bairro}</span>
                  </div>
                  <div className="flex justify-between">
                    <span>CEP:</span>
                    <span className="font-bold text-secundaria">{selectedStreet.cep}</span>
                  </div>
                </div>
              </div>
            )}

            <button
              type="button"
              disabled={!selectedStreet}
              onClick={() => {
                onSelect(selectedStreet);
                onClose();
              }}     
              className="flex items-center gap-x-2 w-fit mt-5 mx-auto text-white bg-quaternaria px-8 py-4 rounded font-bold credit-button-solicitacao"
            >
              Confirmar
            </button>
          </>
        ) : (
          <div className="w-full flex justify-center items-center">
            <Loader />
          </div>
        )}
      </div>
    </div>
  );
};

export default ModalCepOperacional;
